module.exports = angular.module('msi.frequency', [
  require('@ordergroove/brandy/src/app/subscriptions/service'),
  require('@ordergroove/brandy/src/app/frequency/frequency.domain'),
  require('@ordergroove/brandy/src/app/toasts'),
  require('./frequency-control')
]).name;


angular.module(module.exports)
  .provider('frequencies', require('./frequencies'));
